import PropTypes from 'prop-types';
export var metadata = PropTypes.shape({
  country_calling_codes: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
});
export var labels = PropTypes.objectOf(PropTypes.string);
//# sourceMappingURL=PropTypes.js.map